module.exports = __webpack_public_path__ + "static/media/css.6971ddc7.svg";